import React, { Component } from 'react';
import { Telefone, Email } from '../../../Componentes';
import api from '@api';

export default class ListarCamposDeEstagio extends Component {
	constructor() {
		super();
		this.state = {
			listaDeCampos: [],
			loadingIds: [],
		};

		this.carregarListaDeCampos = this.carregarListaDeCampos.bind(this);
	}

	UNSAFE_componentWillMount() {
		this.carregarListaDeCampos();
	}

	carregarListaDeCampos() {
		api.camposDeEstagio.ListaTodos()
			.then((listaDeCampos) => {
				this.setState({ listaDeCampos });
			})
			.catch((erro) => {
				console.log('erro', erro);
			});
	}

	linkParaBaixarModeloDeAteste(id) {
		return `${api.camposDeEstagio.getBaseUrl()}/${id}/baixar`;
	}

	isLoading(id) {
		return this.state.loadingIds.includes(id);
	}

	setLoading(id) {
		this.setState(state => state.loadingIds.includes(id)
			? state
			: ({
				...state,
				loadingIds: [...state.loadingIds, id],
			}));
	}

	setLoaded(id) {
		this.setState(state => !state.loadingIds.includes(id)
			? state
			: ({
				...state,
				loadingIds: state.loadingIds.filter(v => v !== id),
			}));
	}

	async baixar(id) {
		const token = api.auth.accessToken();
		const link = this.linkParaBaixarModeloDeAteste(id);

		this.setLoading(id);
		await fetch(link, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then(res => res.arrayBuffer())
			.then(buffer => {
				const blob = new Blob([buffer], { type: 'application/pdf' });
				const blobUrl = URL.createObjectURL(blob);

				this.setState(prevState => {
					const { listaDeCampos } = prevState;

					const campo = listaDeCampos.filter(campo => campo.id === id)[0];
					const campoAtualizado = { ...campo, blobUrl };

					const listaDeCamposAtualizada = listaDeCampos.reduce((listaNova, valorOriginal) => {
						listaNova.push(valorOriginal.id === id ? campoAtualizado : valorOriginal);
						return listaNova;
					}, []);

					return ({
						...prevState,
						listaDeCampos: [...listaDeCamposAtualizada],
					});
				});
			});
		this.setLoaded(id);
	}

	render() {
		const { listaDeCampos } = this.state;

		return (
			<div>
				<h5>Relação de Campos de Estágio</h5>
				<table className="table table-striped table-hover">
					<thead>
						<tr>
							<th>Local</th>
							<th>Contatos</th>
							<th>Endereço</th>
							<th>Ateste (formulário)</th>
						</tr>
					</thead>
					<tbody>
						{
							listaDeCampos.map(({ endereco, concedente, ...campo }) => (
								<tr key={campo.id}>
									<td>
										{campo.nome}
										<div><small>{concedente !== null ? `Concedente: ${concedente.nome}` : ''}</small></div>
									</td>
									<td>
										<div><Telefone value={campo.telefone} /></div>
										<div><Email value={campo.email} /></div>
									</td>
									<td>
										{endereco.logradouro}, {endereco.bairro}, {endereco.cidade}-{endereco.uf} ({endereco.cep})
									</td>
									<td>
										{campo.blobUrl === undefined
											? this.isLoading(campo.id)
												? 'Baixando...'
												: <button onClick={() => this.baixar(campo.id)}>Baixar</button>
											: <button onClick={() => window.open(campo.blobUrl, '_blank')}>Abrir</button>}
									</td>
								</tr>
							))
						}
					</tbody>
				</table>
			</div>
		);
	}
}
